import React from "react";
import {AutoComplete, Button, Card, DatePicker, Select, Table} from "antd";
import PropTypes from "prop-types";
import {sanitizeFieldName} from "../../util/methods";
import AccessControl from "../AccessControl";
import moment from "moment";

const {Option} = Select;

const getColumns = (columns) => {
  return Object.keys(columns).map(item => {
    if (columns[item].options && columns[item].options.notVisible) {
      return null;
    }
    if (item === '_id' || item === 'password') {
      return null;
    }

    return <Option key={columns[item].field}
                   value={columns[item].field}>{sanitizeFieldName(columns[item].field)}</Option>;
  });
};

const ListCard = ({title, columns, data, handleChange, columnChange, clearFilter, create, size, pagination, loading, filters, authUser, selectLocation, visibleColumn, allLocation, selectJobCard, selectedDate, selectDate, jobCardSearchChange, searchedJobCard, downloadToCSV}) => {
  return (
    <Card className={`gx-card-metrics`}>
      <div className=''>
        <div className='action-bar'>
          {
            title === 'JobCard' ? <AutoComplete
              onSelect={(id) => selectJobCard(id)}
              onChange={jobCardSearchChange}
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder={'Search Job Card'} >
              {
                searchedJobCard && searchedJobCard.map((item) => {
                  return <Select.Option key={item._id} value={item._id}>{item.jobCardNo}</Select.Option>
                })
              }
            </AutoComplete> : <div style={{width: '100%'}}>
              <DatePicker className='gx-mr-2' defaultValue={selectedDate || moment(Date.now()) } onChange={(date, dateString) => selectDate(date)}/>
              <Select
                allowClear
                showSearch
                onChange={(id) => selectLocation(id || '')}
                style={{ width: '40%'}}
                onSelect={(id) => selectLocation(id)}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                placeholder={'Search Location'} >
                {
                  allLocation && allLocation.map((item) => {
                    return <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>
                  })
                }
              </Select>
            </div>
          }

          <div className='action-bar'>

            <AccessControl resource={title} permissionNeeded={'c'}
                           roles={authUser ? authUser.roles : []} render={(props) => {
              return <Button style={{marginRight: '10px'}} disabled={columns.length <= 1} onClick={downloadToCSV}>Download to CSV</Button>;
            }}/>

            {
              <AccessControl resource={title} permissionNeeded={'r'}
                             roles={authUser ? authUser.roles : []} render={(props) => {
                return (visibleColumn && visibleColumn.length ?
                  (<Select mode="multiple" maxTagCount={1} key={'1'}
                           style={{width: '200px', marginRight: '10px'}}
                           placeholder="Visible Columns"
                           defaultValue={visibleColumn}
                           onChange={columnChange}>
                    {getColumns(filters)}
                  </Select>)
                  : (<Select mode="multiple" maxTagCount={1} key={'2'}
                             style={{width: '200px', marginRight: '10px'}}
                             placeholder="Visible Columns"
                             defaultValue={visibleColumn}
                             onChange={columnChange}>
                    {getColumns(filters)}
                  </Select>))
              }}/>
            }


            <Button onClick={clearFilter}>Clear filters and sorters</Button>
          </div>
        </div>
        <Table columns={columns} dataSource={data} onChange={handleChange} size={size} rowKey={'_id'}
               pagination={pagination} loading={loading}/>
      </div>
    </Card>
  )
};

export default ListCard;
ListCard.defaultProps = {
  size: "middle"
};

ListCard.propTypes = {
  title: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  columnChange: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  size: PropTypes.string,
  data: PropTypes.array.isRequired,
  create: PropTypes.func,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  filters: PropTypes.object,
  visibleColumn: PropTypes.array
};
